import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import koCommon from './locales/ko/common.json'
import koSidebar from './locales/ko/sidebar.json'
import koRealtime from './locales/ko/realtime.json'
import koHeader from './locales/ko/header.json'
import koAuth from './locales/ko/auth.json'
import koDashboard from './locales/ko/dashboard.json'
import koUsers from './locales/ko/users.json'
import koDeposits from './locales/ko/deposits.json'
import koWithdrawals from './locales/ko/withdrawals.json'
import koTrading from './locales/ko/trading.json'
import koStatistics from './locales/ko/statistics.json'
import koInquiries from './locales/ko/inquiries.json'

import enCommon from './locales/en/common.json'
import enSidebar from './locales/en/sidebar.json'
import enRealtime from './locales/en/realtime.json'
import enHeader from './locales/en/header.json'
import enAuth from './locales/en/auth.json'
import enDashboard from './locales/en/dashboard.json'
import enUsers from './locales/en/users.json'
import enDeposits from './locales/en/deposits.json'
import enWithdrawals from './locales/en/withdrawals.json'
import enTrading from './locales/en/trading.json'
import enStatistics from './locales/en/statistics.json'
import enInquiries from './locales/en/inquiries.json'

import jaCommon from './locales/ja/common.json'
import jaSidebar from './locales/ja/sidebar.json'
import jaRealtime from './locales/ja/realtime.json'
import jaHeader from './locales/ja/header.json'
import jaAuth from './locales/ja/auth.json'
import jaDashboard from './locales/ja/dashboard.json'
import jaUsers from './locales/ja/users.json'
import jaDeposits from './locales/ja/deposits.json'
import jaWithdrawals from './locales/ja/withdrawals.json'
import jaTrading from './locales/ja/trading.json'
import jaStatistics from './locales/ja/statistics.json'
import jaInquiries from './locales/ja/inquiries.json'

import zhCommon from './locales/zh/common.json'
import zhSidebar from './locales/zh/sidebar.json'
import zhRealtime from './locales/zh/realtime.json'
import zhHeader from './locales/zh/header.json'
import zhAuth from './locales/zh/auth.json'
import zhDashboard from './locales/zh/dashboard.json'
import zhUsers from './locales/zh/users.json'
import zhDeposits from './locales/zh/deposits.json'
import zhWithdrawals from './locales/zh/withdrawals.json'
import zhTrading from './locales/zh/trading.json'
import zhStatistics from './locales/zh/statistics.json'
import zhInquiries from './locales/zh/inquiries.json'

const resources = {
  ko: {
    common: koCommon, sidebar: koSidebar,
    realtime: koRealtime, header: koHeader, auth: koAuth,
    dashboard: koDashboard, users: koUsers, deposits: koDeposits, withdrawals: koWithdrawals,
    trading: koTrading, statistics: koStatistics, inquiries: koInquiries,
  },
  en: {
    common: enCommon, sidebar: enSidebar,
    realtime: enRealtime, header: enHeader, auth: enAuth,
    dashboard: enDashboard, users: enUsers, deposits: enDeposits, withdrawals: enWithdrawals,
    trading: enTrading, statistics: enStatistics, inquiries: enInquiries,
  },
  ja: {
    common: jaCommon, sidebar: jaSidebar,
    realtime: jaRealtime, header: jaHeader, auth: jaAuth,
    dashboard: jaDashboard, users: jaUsers, deposits: jaDeposits, withdrawals: jaWithdrawals,
    trading: jaTrading, statistics: jaStatistics, inquiries: jaInquiries,
  },
  zh: {
    common: zhCommon, sidebar: zhSidebar,
    realtime: zhRealtime, header: zhHeader, auth: zhAuth,
    dashboard: zhDashboard, users: zhUsers, deposits: zhDeposits, withdrawals: zhWithdrawals,
    trading: zhTrading, statistics: zhStatistics, inquiries: zhInquiries,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ko',
    defaultNS: 'common',
    ns: [
      'common', 'sidebar', 'header', 'auth', 'dashboard', 'users',
      'deposits', 'withdrawals', 'trading', 'statistics', 'inquiries',
    ],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'partner_language',
      caches: ['localStorage'],
    },
  })

export default i18n
